import React from 'react';
import { RefreshCw, ChevronRight } from 'lucide-react';

const WorkerExtraCards = ({ setSwitchModal }) => {
  return (
    <div className="wp-extra-cards">
      <div className="wp-extra-card wp-extra-card--switch" onClick={() => setSwitchModal(true)}>
        <div className="wp-extra-card__left">
          <div className="wp-extra-card__icon" style={{ background: 'rgba(139,92,246,0.12)', color: '#8b5cf6' }}>
            <RefreshCw size={18} />
          </div>
          <div className="wp-extra-card__info">
            <span className="wp-extra-card__label">Switch to Seeker</span>
            <span className="wp-extra-card__sub">Login as a Seeker to book services</span>
          </div>
        </div>
        <ChevronRight size={16} className="wp-extra-card__arrow" />
      </div>
    </div>
  );
};

export default WorkerExtraCards;